export const NAV_ITEMS = [
  { label: "Home", path: "/", testId: "nav-link-home" },
  { label: "About Us", path: "/about-us", testId: "nav-link-about-us" },
  { label: "Products", path: "/products", testId: "nav-link-products" },
  { label: "Services", path: "/services", testId: "nav-link-services" },
  { label: "Why Choose Us", path: "/why-choose-us", testId: "nav-link-why-choose-us" },
  { label: "FAQ", path: "/faq", testId: "nav-link-faq" },
  { label: "Contact Us", path: "/contact-us", testId: "nav-link-contact-us" },
];

export const COMPANY_INFO = {
  name: "RKG NATURALS",
  owner: "Jyoti K. Gaware",
  businessType: "Proprietorship – Import • Export • Wholesale",
  domain: "rkgnaturals.com",
  whatsappNumber: "918830225875",
  whatsappDisplay: "+91 88302 25875",
  whatsappLink: "https://wa.me/918830225875",
  emailPrimary: "export@rkgnaturals.com",
  emailSecondary: "rkgimportexport95@gmail.com",
  address:
    "Flat No. 304, B4, Bhumikh Darshan Building, Umiya Complex Phase II, Titwala, Kalyan, Thane, Maharashtra – 421605, India",
  workingHours: "24/7",
  mapsLink: "https://maps.app.goo.gl/C1g1aBvqqFndtfL18?g_st=aw",
};
